export default {
  list: [
    {
      title: 'عادی',
      value: 'NORMAL'
    },
    {
      title:'Takeaway',
      value: 'TAKEAWAY'
    }
  ],
  values: {
    NORMAL: 'NORMAL',
    TAKEAWAY: 'TAKEAWAY',
  }
};
